import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import { tokenManager } from "./token-manager.js";
const authMiddleware = {
    async onRequest({ request }) {
        const token = tokenManager.getToken();
        if (token) {
            request.headers.set("Authorization", `Bearer ${token}`);
        }
        return request;
    },
    async onResponse({ response }) {
        if (response.status === 401) {
            console.error("Authentication error (401)");
        }
        if (response.status === 403) {
            console.error("Access denied (403)");
        }
        if (response.status >= 500) {
            console.error(`Server error (${response.status}): ${response.url}`);
        }
        return response;
    },
    async onError({ error }) {
        // Ignored aborted requests (e.g. React StrictMode double-mount, navigation, unmount)
        if (error instanceof DOMException && error.name === "AbortError") {
            throw error;
        }
        // Network errors (ERR_NETWORK, ERR_CONNECTION_REFUSED, timeouts, etc.)
        console.error("Network error:", error);
        throw error;
    },
};
export const createConfigurationApi = (baseUrl) => {
    const client = createFetchClient({ baseUrl });
    client.use(authMiddleware);
    return {
        client,
        ...createClient(client),
    };
};
export const createFileApi = (baseUrl) => {
    const client = createFetchClient({ baseUrl });
    client.use(authMiddleware);
    return {
        client,
        ...createClient(client),
    };
};
export const createAuthApi = (baseUrl) => {
    const client = createFetchClient({ baseUrl });
    client.use(authMiddleware);
    return {
        client,
        ...createClient(client),
    };
};
//# sourceMappingURL=apis.js.map